<template>
  <highcharts :key="hcKey" :options="chartOptions" ref="riyVsRhpChart"></highcharts>
</template>
<script>
import { rhpToYears, setChartMenuItemsLang } from '../../../utils/formatter'

export default {
  name: 'riy-vs-rhp-chart',
  props: {
    value: {},
    title: {},
    isInvestmentCertificates: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hcKey: 0,
    }
  },
  computed: {
    chartOptions: function () {
      let vueThis = this
      return {
        lang: this.setOptions,
        chart: {
          type: 'scatter',
          zoomType: 'xy',
          backgroundColor: '#FFFFFF',
          height: '50%',
        },
        credits: {
          enabled: false,
        },
        legend: {
          enabled: !this.isInvestmentCertificates,
        },
        title: {
          text: this.title,
          style: { fontSize: '25px', fontWeight: 'bold' },
        },
        tooltip: {
          useHTML: true,
          formatter: function () {
            return (
              '<b class="hc-tooltip-title">' +
              this.point.meta.name +
              '</b><br>' +
              '<b>' +
              this.point.meta.issuerName +
              '</b><br>' +
              (this.point.meta.structureType === 2
                ? '<b>' +
                  vueThis.$t('search.resultTable.riyMin') +
                  '</b>: ' +
                  vueThis.$n(this.point.meta.riyMin, 'percent') +
                  '<br>' +
                  '<b>' +
                  vueThis.$t('search.resultTable.riyMax') +
                  '</b>: ' +
                  vueThis.$n(this.point.meta.riyMax, 'percent')
                : '<b>' +
                  vueThis.$t('search.resultTable.riy') +
                  '</b>: ' +
                  vueThis.$n(this.point.meta.riyMin, 'percent'))
            )
          },
        },
        xAxis: {
          gridLineWidth: 2,
          allowDecimals: false,
          title: {
            text: 'RHP',
          },
          labels: {
            formatter: (el) => rhpToYears(el.value),
          },
          tickInterval: 1,
        },
        yAxis: {
          title: {
            text: 'RIY',
          },
          labels: {
            formatter: (el) => this.$n(el.value, 'percent'),
          },
        },
        series: [
          {
            name: 'MOP (RIY Min)',
            data: this.chartData.filter((el) => el.meta.structureType === 2 && el.y === el.meta.riyMin),
          },
          {
            name: 'MOP (RIY Max)',
            data: this.chartData.filter((el) => el.meta.structureType === 2 && el.y === el.meta.riyMax),
          },
          {
            name: 'Single RIY',
            data: this.chartData.filter((el) => el.meta.structureType === 1),
          },
        ],
      }
    },
    chartData: function () {
      if (this.value.length === 0) {
        return []
      }
      return this.value.map((el) => {
        return {
          x: el.rhp,
          y: el.riy,
          meta: {
            name: el.productKey.name,
            issuerName: el.productKey.issuerName,
            riyMin: el.riyMin,
            riyMax: el.riyMax,
            structureType: el.structureType,
          },
        }
      })
    },
    setOptions() {
      this.hcKey += 1
      return setChartMenuItemsLang()
    },
  },
}
</script>
<style lang="scss" scoped>
input:not([type='checkbox']),
select {
  width: 100%;
}

#optTabChart label {
  border: 0px;
  background-color: transparent !important;
  color: gray;
  box-shadow: none;
  padding: 1rem 0rem 0rem 1rem;
}
</style>
